/* eslint-disable spire/export-styles */

import React, { FC } from "react";
import styled, { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import { connect } from "react-redux";

type Props = WidgetProps;

const Navigation = styled.div`
    color: ${getContrastColor("common.accent")};
    font-size: 15px;
    background-color: ${getColor("common.accent")};
    padding: 9px 45px 4px 45px;
    text-transform: uppercase;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const NavItem = styled.span<InjectableCss>`
    display: inline-flex;

    > span,
    > a {
        margin-left: 10px;
    }
    ${injectCss}
`;

export interface TickerStyles {
    wrapper?: InjectableCss;
    container?: InjectableCss;
    phoneNumber?: InjectableCss;
    quickOrder?: InjectableCss;
    divider?: InjectableCss;
}

const styles: TickerStyles = {
    wrapper: {
        css: css`
            max-width: 100%;
            background-color: ${getColor("common.accent")};
        `,
    },
    container: {
        css: css`
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin: 0 auto;
            & .containerItems {
                margin: 0 7px;
                &.quickOrder {
                    margin-right: 0;
                }
            }
            & .specialsWrapper {
                display: flex;
                align-items: center;
                & .specialText {
                    font-size: 16px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 14px;
                                `,
                                css`
                                    font-size: 14px;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
            & .phoneNumber {
                a {
                    position: relative;
                    margin-left: 25px;
                    & img {
                        height: 18px;
                        width: 18px;
                    }
                    span[class^="LazyImageStyle"] {
                        position: absolute;
                        left: -24px;
                    }
                }
            }
        `,
    },
    divider: {
        css: css`
            display: inline-block;
            height: 40px;
            width: 0.2px;
            background: #cccccc;
            margin-left: 20px;
        `,
    },
};

export const tickerStyles = styles;

const Ticker: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.container}>
                <StyledWrapper className="containerItems specialsWrapper">
                    <Zone zoneName="Specials" contentId={id} />
                    <StyledWrapper {...styles.divider}></StyledWrapper>
                </StyledWrapper>
                <StyledWrapper className="containerItems">
                    <Zone zoneName="PhoneNumber" contentId={id} />
                </StyledWrapper>
                <StyledWrapper className="containerItems quickOrder">
                    <Zone zoneName="QuickOrder" contentId={id} />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const ticker: WidgetModule = {
    component: Ticker,
    definition: {
        group: "Common",
        icon: "NavigationList",
    },
};

export default ticker;
